module.exports = __webpack_public_path__ + "3636a71f45a1342b98355ee7a7afd5ba.svg";